import React from 'react'
import AccountingTransactions from 'src/components/AccountingTransactions/AccountingTransactions'
import LayoutShell from 'src/components/LayoutShell/LayoutShell'
import { SubnavDesign } from 'src/components/Subnav/Subnav'
import Trns from 'src/localization/Trns'

import styles from './AccountingTransactionsShell.style'

const AccountingTransactionsShell: React.FC = () => {

  return <LayoutShell
      className={"AccountingTransactions"}
      css={styles}
      subnavDesign={SubnavDesign.Floating}
      subnavOptions={[]}
      content={
       <AccountingTransactions />
      }
      title={<Trns source={'Card Transactions'} />}
      // subtitle={translate('Confirm spend, receipts, and coding, finalize approvals, and keep your books accurate')}
      /* @ts-ignore next-line */
      buttons={[]}
    />
}

export default AccountingTransactionsShell
